var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_png_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.953,
    height: 90.026,
    viewBox: "0 0 78.953 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139282",
    "data-name": "\\uD328\\uC2A4 139282",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.22 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139283",
    "data-name": "\\uD328\\uC2A4 139283",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139284",
    "data-name": "\\uD328\\uC2A4 139284",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139285",
    "data-name": "\\uD328\\uC2A4 139285",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139286",
    "data-name": "\\uD328\\uC2A4 139286",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139287",
    "data-name": "\\uD328\\uC2A4 139287",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.364)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139288",
    "data-name": "\\uD328\\uC2A4 139288",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#76a34f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139289",
    "data-name": "\\uD328\\uC2A4 139289",
    d: "M8.054.418.18,11.642a.982.982,0,0,0,.8,1.546H16.732a.982.982,0,0,0,.8-1.546L9.662.418A.982.982,0,0,0,8.054.418Z",
    transform: "translate(17.981 51.485)",
    fill: "#648940"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139290",
    "data-name": "\\uD328\\uC2A4 139290",
    d: "M15.231.418.18,21.874a.982.982,0,0,0,.8,1.546h30.1a.982.982,0,0,0,.8-1.546L16.84.418A.982.982,0,0,0,15.231.418Z",
    transform: "translate(33.676 41.254)",
    fill: "#648940"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139368",
    "data-name": "\\uD328\\uC2A4 139368",
    d: "M3.927,0A3.927,3.927,0,1,1,0,3.927,3.927,3.927,0,0,1,3.927,0Z",
    transform: "translate(22.911 40.526)",
    fill: "#91b56b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139369",
    "data-name": "\\uD328\\uC2A4 139369",
    d: "M2.274,7.049v3.535H0V.2H3.928a4.884,4.884,0,0,1,3.066.823A2.879,2.879,0,0,1,8.041,3.432,3.28,3.28,0,0,1,6.884,6.067a4.505,4.505,0,0,1-3.018.982ZM2.26,1.833V5.4h.606A3.736,3.736,0,0,0,5.13,4.93a1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42Zm16.527,8.751H16.6L11.938,2.97v7.614H9.829V.2h2.756l4.093,6.711V.2h2.109ZM30.16,9.943a10.406,10.406,0,0,1-3.948.861,5.5,5.5,0,0,1-4.028-1.426,5.351,5.351,0,0,1-1.45-4,5.245,5.245,0,0,1,1.485-3.928A5.537,5.537,0,0,1,26.267,0a8.97,8.97,0,0,1,3.866.916V3.025h-.241A7.414,7.414,0,0,0,27.9,1.871a4.918,4.918,0,0,0-1.488-.245,3.061,3.061,0,0,0-2.4.989,3.939,3.939,0,0,0-.885,2.725,4.1,4.1,0,0,0,.913,2.877,3.428,3.428,0,0,0,2.649.989,4.353,4.353,0,0,0,1.247-.172V6.67H25.612V5.016H30.16Z",
    transform: "translate(7.375 9.083)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaPngIcon);
export default __webpack_public_path__ + "static/media/minerva_png_icon.595d5130e1c4151de38d4e606d84c80e.svg";
export { ForwardRef as ReactComponent };